<template>
	<div class="quanxianfenpei">

		<el-scrollbar id="menuWarpper" style="height:calc(100%);">
			<div class="header" ref="header">
				<div class="headerTop">
					<div class="header-con">
						<el-form class="header-con-form" :inline="true">
							<el-form-item class="header-con-form-item" label="工单:">
								<el-input v-model="gongdan" class="form-item-inputcpx" placeholder="请输入"
									@keyup.enter.native="ChaXun()">
								</el-input>
							</el-form-item>

							<el-form-item class="header-con-form-item" label="状态:">

								<el-select class="form-item-inputcpx" v-model="zhanghaozhuangtai" filterable
									placeholder="输入关键词搜索" :filter-method="bindSelectChange" @change="dianjichanpinxian"
									popper-class="eloption" :popper-append-to-body="false">
									<el-option v-for="item in staff" :key="item.Code" :label="item.Name"
										:value="item.Code">
									</el-option>
								</el-select>
								<!-- <el-input v-model="templateName" style="width: 200px" placeholder="请输入"></el-input> -->
							</el-form-item>

						</el-form>
						<el-button type="success" @click="ChaXun()" :disabled="isChaXun">查询</el-button>
						<el-button type="danger" @click="piliangshanchu()" :disabled="isShanChu">批量删除</el-button>
					</div>

				</div>
			</div>
			<div class="main" v-bind:style="{height:EchartsHeight}">
				<el-table ref="tableData" :data="tableData.slice((currPage-1)*pageSize,currPage*pageSize)" height="100%"
					Boolean highlight-current-row resizable stripe border @selection-change="handleSelectionChange">
					<el-table-column align="center" type="selection" label="序号" width="50">
					</el-table-column>
					<el-table-column align="center" type="index" label="序号" width="50">
					</el-table-column>
					<el-table-column align="center" prop="TITLE" label="名称" width="150">
					</el-table-column>
					<el-table-column align="center" prop="TOUTE" label="路径" width="200">
					</el-table-column>
					<el-table-column align="center" prop="SORT" label="排序" width="80">
					</el-table-column>
					<el-table-column align="center" prop="STATUS" label="状态" width="100">
						<template slot-scope="scope">
							<div v-if="scope.row.STATUS==1">启用</div>
							<div v-if="scope.row.STATUS==0">禁用</div>

						</template>
					</el-table-column>
					<el-table-column align="center" prop="CREATE_TIME" label="创建时间" width="150">
						<template v-if="scope.row.CREATE_TIME!=null" slot-scope="scope">
							{{scope.row.CREATE_TIME.toLocaleString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')}}

						</template>
					</el-table-column>
					<el-table-column align="center" label="操作" fixed="right" width="210px">
						<template slot-scope="scope">
							<el-button type="primary" @click="xiugai(scope)">修改</el-button>
							<el-button type="warning" @click="jinyong(scope)" v-if="scope.row.STATUS==1"
								:disabled="isJinYong">禁用</el-button>
							<el-button type="success" @click="qiyong(scope)" v-if="scope.row.STATUS==0"
								:disabled="isJinYong">启用</el-button>
							<el-button type="danger" @click="shanchu(scope)" :disabled="isShanChua">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<div class="footer" ref="footer">
				<pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage" @hanSiChange="hanSiChange"
					@hanCurrChange="hanCurrChange"></pagination>
			</div>

		</el-scrollbar>

	</div>
</template>

<script>
	import PinyinMatch from "pinyin-match";

	export default {
		name: "chaxunquanxian",
		data() {
			return {
				isJinYong: false,
				isShanChua: false,
				isShanChu: false,
				isChaXun: false,
				multipleSelection: [],
				gongdan: "",
				zhanghaozhuangtai: '-1',
				EchartsHeight: (document.body.clientHeight - 200) + 'px',
				currPage: 1,
				pageSize: 50,
				allPage: 0,
				tableData: [],
				staffcopy: [{
						Code: "-1",
						Name: "全部"
					},
					{
						Code: "1",
						Name: "启用"
					},
					{
						Code: "0",
						Name: "禁用"
					}
				],
				staff: [{
						Code: "-1",
						Name: "全部"
					},
					{
						Code: "1",
						Name: "启用"
					},
					{
						Code: "0",
						Name: "禁用"
					}
				], //状态
				staffz: [{
						Code: "-1",
						Name: "全部"
					},
					{
						Code: "1",
						Name: "启用"
					},
					{
						Code: "0",
						Name: "禁用"
					}
				],

			};
		},

		mounted() {

			const that = this;
			window.onresize = () => {
				// return (() => {
				window.screenHeight = document.body.clientHeight
				that.EchartsHeight = (window.screenHeight - 200) + 'px'
				if (this.$refs.tableData && this.$refs.tableData.doLayout) {
					this.$refs.tableData.doLayout();
				}

				// })()
			}


			this.ChaXun();


		},
		beforeRouteEnter(to, form, next) {
			next(vm => {

				vm.ChaXun()

			})

		},

		updated() {
			// myTable是表格的ref属性值
			if (this.$refs.tableData && this.$refs.tableData.doLayout) {
				this.$refs.tableData.doLayout();
			}
		},
		methods: {
			handleSelectionChange(val) {

				this.multipleSelection = val;
			},
			dianjichanpinxian() {
				this.staff = this.staffz;
				this.ChaXun()
			},
			bindSelectChange(val) {

				if (val) {
					this.staff = this.staffcopy.filter((item) => {
						return PinyinMatch.match(item.Name, val) //(需要过滤的名称，输入的关键词)
					})
				} else {
					this.staff = this.staffcopy
				}

			},

			//查询
			ChaXun() {

				this.loading = true;
				this.isChaXun = true;

				this.$request({
						method: "GET",
						url: '/Power/GetPowerList?status=' + encodeURIComponent(this.zhanghaozhuangtai) +
							"&title=" + encodeURIComponent(this.gongdan) + "&role=0",
					})
					.then((res) => {

						this.loading = false;
						if (res.Code == '0' || res.Code == 0) {
							this.tableData = res.Data;
							this.$nextTick(() => {
								// myTable是表格的ref属性值
								if (this.$refs.tableData && this.$refs.tableData.doLayout) {
									this.$refs.tableData.doLayout();
								}
							})

						}

						this.currPage = 1;
						this.allPage = this.tableData.length;

						// setTimeout(() => {
						this.isChaXun = false;
						// }, 2000)
					})
					.catch((err) => {
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
						this.isChaXun = false;

					});


			},
			/**修改 */
			xiugai(row) {
				this.$router.push({
					path: "quanxianweihu",
					query: {
						qianyiyemianglujing: "/home/chaxunquanxian",
						qianyiyemingcheng: '权限查询',
						arr: JSON.stringify(row.row), //数组
					}
				});

			},
			/**启用 */
			qiyong(row) {

				this.genggaizhuangtai("启用", row.row.ID)
			},
			/**禁用 */
			jinyong(row) {

				this.genggaizhuangtai("禁用", row.row.ID)

			},
			/**删除 */
			shanchu(row) {
				var arr = [];
				arr.push(row.row.ID)
				this.isShanChua = true;
				this.$confirm('此操作将永久删除该' + row.row.TITLE + ',是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$request({
							method: "POST",
							url: 'Power/Delete',
							data: JSON.stringify(arr)

						})
						.then((res) => {
							this.$message({
								message: res.Msg,
								type: "success",
							});
							this.isShanChua = false;
							this.ChaXun()

						})
						.catch((err) => {
							this.isShanChua = false;
							if (err == "Error: Request failed with status code 401") {
								this.$router.push({
									path: "/login",
								});
							}
						});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			piliangshanchu() {
				var arr = [];
				this.isShanChu = true;
				// var url='Power/Delete?array=';
				var url = 'Power/Delete';
				for (var z in this.multipleSelection) {
					arr.push(this.multipleSelection[z].ID);
				}

				if (arr.length > 0) {

					this.$confirm('删除不可逆，确定批量删除么?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {

						this.$request({
								method: "POST",
								url: url,
								data: JSON.stringify(arr)
							})
							.then((res) => {
								this.$message({
									message: res.Msg,
									type: "success",
								});
								this.isShanChu = false;
								this.ChaXun()

							})
							.catch((err) => {
								this.isShanChu = false;
								if (err == "Error: Request failed with status code 401") {
									this.$router.push({
										path: "/login",
									});
								}
							});
					}).catch(() => {
						this.isShanChu = false;
						this.$message({
							type: 'info',
							message: '已取消批量删除'
						});
					});

				}
			},
			/**更改状态*/
			genggaizhuangtai(value, ID) {
				this.isJinYong = true;
				var zhuangtai = '2';
				if (value == "禁用") {
					zhuangtai = '0';
				} else {
					zhuangtai = '1';
				}
				let data = {

					ID: ID, //序号
					STATUS: zhuangtai, //客服工号


				};
				// this.formDialog = true;

				this.scoped = true;

				this.$request({
						method: "post",
						url: "Power/ModifyPowerStatus",
						data: data,
					})
					.then((res) => {
						this.$message({
							message: value + res.Msg,
							type: "success",
						});
						this.isJinYong = false;
						this.ChaXun()

					})
					.catch((err) => {
						this.isJinYong = false;
						if (err == "Error: Request failed with status code 401") {
							this.$router.push({
								path: "/login",
							});
						}
					});
			},

			/**分页size改变 */
			hanSiChange(val) {
				this.pageSize = val;
				this.ChaXun();
			},
			/**当前页改变 */
			hanCurrChange(val) {
				this.currPage = val;
				this.ChaXun();
			},
			/**刷新表格数据 */
			handleRefresh() {
				this.ChaXun();
			},


		},
	};
</script>

<style scoped>
	.quanxianfenpei {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		/* padding: 20px; */
		padding-left: 0px;
		background-color: #F0F0F0;
	}


	/deep/ .el-dialog {
		max-height: 80%;
	}

	/* 主体容器 */
	.main {
		margin-top: 10px;
		padding: 15px;
		background-color: #FFFFFF;

		overflow-y: auto;
		margin-right: 0px;
	}


	/**底部分页 */
	.footer {
		height: 50px;
		margin-right: 0px;
	}

	/* 头部选择模板名称 */
	.header {
		height: auto;
		background-color: #FFFFFF;
		padding-left: 20px;
		padding-top: 10px;
		padding-bottom: 5px;
		/* width: calc(100%-10px); */
	}

	.headerTop {
		display: flex;
		justify-content: space-between;
	}

	.header-con {
		height: 40px;
		/* width: calc(100%-200px); */
		display: flex;
		align-items: center;
	}

	.header-con-form {
		display: flex;
		align-items: center;
	}

	.header-con-form-item {
		margin-bottom: 0;
	}

	.el-table {
		overflow-y: auto !important;
		overflow-x: auto !important;
	}
</style>
